const OWNER_EMAIL = 'sameer@demistai.co';
const OWNER_USER_ID = 1;

export function isOwnerToolsUser(user) {
  if (!user) return false;
  const email = (user.email || '').trim().toLowerCase();
  return user.id === OWNER_USER_ID || email === OWNER_EMAIL;
}
